import React, { useEffect } from "react";

const SITE_URL = "https://marstick.com";

const extractHowToSteps = (content = "") => {
  if (!/(step-by-step|steps|checklist|how to|procedure)/i.test(content)) return [];
  return String(content || "")
    .split("\n")
    .map((line) => line.trim())
    .filter((line) => /^\d+\.\s+/.test(line) || /^[-*]\s+/.test(line))
    .map((line) => line.replace(/^\d+\.\s+/, "").replace(/^[-*]\s+/, "").replace(/\*\*/g, "").trim())
    .filter(Boolean)
    .slice(0, 8);
};

export default function LearningStructuredData({ type = "Article", article, topic, url, breadcrumbs = [], faq = [] }) {
  useEffect(() => {
    const id = "learning-structured-data";
    document.getElementById(id)?.remove();

    const graph = [
      {
        "@type": "Organization",
        "@id": `${SITE_URL}/#organization`,
        name: "Marstick",
        url: SITE_URL,
        logo: `${SITE_URL}/apple-touch-icon.png`,
      },
      {
        "@type": "WebSite",
        "@id": `${SITE_URL}/#website`,
        name: "Marstick",
        url: SITE_URL,
        publisher: { "@id": `${SITE_URL}/#organization` },
      },
    ];

    if (breadcrumbs.length) {
      graph.push({
        "@type": "BreadcrumbList",
        itemListElement: breadcrumbs.map((item, index) => ({
          "@type": "ListItem",
          position: index + 1,
          name: item.name,
          item: `${SITE_URL}${item.href}`,
        })),
      });
    }

    if (article) {
      graph.push({
        "@type": type,
        headline: article.title,
        description: article.meta_description || article.excerpt,
        image: article.image_urls?.[0] || topic?.image,
        author: { "@type": "Organization", name: "Marstick Editorial Team" },
        publisher: { "@id": `${SITE_URL}/#organization`, "@type": "Organization", name: "Marstick", logo: { "@type": "ImageObject", url: `${SITE_URL}/apple-touch-icon.png` } },
        datePublished: article.created_date,
        dateModified: article.updated_date,
        inLanguage: url?.split("/")?.[1] || "en",
        mainEntityOfPage: `${SITE_URL}${url}`,
      });
    }

    const howToSteps = extractHowToSteps(article?.content);
    if (howToSteps.length >= 3) {
      graph.push({
        "@type": "HowTo",
        name: article.title,
        description: article.meta_description || article.excerpt,
        step: howToSteps.map((step, index) => ({
          "@type": "HowToStep",
          position: index + 1,
          text: step,
        })),
      });
    }

    if (faq.length) {
      graph.push({
        "@type": "FAQPage",
        mainEntity: faq.map((item) => ({
          "@type": "Question",
          name: item.q || item.question,
          acceptedAnswer: { "@type": "Answer", text: item.a || item.answer },
        })),
      });
    }

    const script = document.createElement("script");
    script.id = id;
    script.type = "application/ld+json";
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);

    return () => document.getElementById(id)?.remove();
  }, [article, topic, url, type, breadcrumbs, faq]);

  return null;
}